import React from 'react';
import { Check } from 'lucide-react';
export function BonusSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="bonus" className="py-4 sm:py-16 bg-[#0f172a] relative" data-id="element-30">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-31">
        <div className="text-center mb-3 sm:mb-10" data-id="element-32">
          <h2 className="text-base sm:text-3xl md:text-4xl font-bold text-white mb-1.5" data-id="element-33">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <p className="text-[10px] sm:text-base text-gray-300 max-w-2xl mx-auto mb-2" data-id="element-34">
            Para que tengas respaldo profesional y el año completamente
            organizado, incluimos 2 bonus estratégicos:
          </p>
          <div className="inline-block bg-gradient-to-r from-red-600 to-red-500 text-white font-black text-[10px] sm:text-lg px-3 py-1 rounded-lg shadow-lg border-2 border-white/20 animate-pulse" data-id="element-35">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-2 sm:gap-8" data-id="element-36">
          {/* BONUS 1 */}
          <div className="bg-[#1e293b] rounded-lg sm:rounded-xl overflow-hidden border-2 border-[#fbbf24] shadow-xl shadow-[#fbbf24]/20 flex flex-col" data-id="element-37">
            <div className="bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] p-1.5 sm:p-4 text-center" data-id="element-38">
              <h3 className="text-xs sm:text-2xl font-black text-[#0a1628]" data-id="element-39">
                🎁 BONUS 1
              </h3>
            </div>
            <div className="p-2 sm:p-6 flex-1 flex flex-col" data-id="element-40">
              <div className="w-full mb-2 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/hNBsZcK1ZChMH34GobUgnQ/bonus_1_(3).png" alt="Banco Profesional de Proyectos Organizacionales" className="w-full h-auto max-h-[140px] sm:max-h-none object-contain rounded-md sm:rounded-lg shadow-lg" data-id="element-42" />
              </div>
              <h4 className="text-[11px] sm:text-xl font-bold text-[#fbbf24] mb-1 text-center leading-tight" data-id="element-43">
                Banco Profesional de Proyectos Organizacionales
              </h4>
              <p className="text-gray-300 text-[9px] sm:text-base mb-1.5 text-center hidden sm:block" data-id="element-44">
                Proyectos organizacionales completos listos para aplicar en
                clase.
              </p>
              <p className="text-gray-400 text-[9px] sm:text-sm mb-1 font-medium" data-id="element-45">
                Incluye:
              </p>
              <ul className="space-y-0.5 sm:space-y-1.5 flex-1" data-id="element-46">
                {['Problema organizacional delimitado', 'Objetivos y diagnóstico', 'Planificación del proyecto', 'Actividades organizadas', 'Análisis del impacto', 'Conclusiones modelo'].map((item, i) => <li key={i} className="flex items-center text-gray-200 text-[9px] sm:text-sm" data-id="element-47">
                    <Check className="h-3 w-3 sm:h-4 sm:w-4 text-[#16a34a] mr-1 sm:mr-1.5 flex-shrink-0" strokeWidth={3} data-id="element-48" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          {/* BONUS 2 */}
          <div className="bg-[#1e293b] rounded-lg sm:rounded-xl overflow-hidden border-2 border-[#fbbf24] shadow-xl shadow-[#fbbf24]/20 flex flex-col" data-id="element-49">
            <div className="bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] p-1.5 sm:p-4 text-center" data-id="element-50">
              <h3 className="text-xs sm:text-2xl font-black text-[#0a1628]" data-id="element-51">
                🎁 BONUS 2
              </h3>
            </div>
            <div className="p-2 sm:p-6 flex-1 flex flex-col" data-id="element-52">
              <div className="w-full mb-2 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-53">
                <img src="https://cdn.magicpatterns.com/uploads/tkxsZ6Nxj4YFufHW2D8UQT/bonus_2_(4).png" alt="Planificación Anual Lista" className="w-full h-auto max-h-[140px] sm:max-h-none object-contain rounded-md sm:rounded-lg shadow-lg" data-id="element-54" />
              </div>
              <h4 className="text-[11px] sm:text-xl font-bold text-[#fbbf24] mb-1 text-center leading-tight" data-id="element-55">
                Planificación Anual Lista
              </h4>
              <p className="text-gray-300 text-[9px] sm:text-base mb-1.5 text-center hidden sm:block" data-id="element-56">
                Organizá todo tu año de Proyecto Organizacional sin improvisar.
              </p>
              <p className="text-gray-400 text-[9px] sm:text-sm mb-1 font-medium" data-id="element-57">
                Incluye:
              </p>
              <ul className="space-y-0.5 sm:space-y-1.5 flex-1" data-id="element-58">
                {['Cronograma anual organizado', 'Secuencia completa de contenidos', 'Organización del proyecto final', 'Entregas parciales planificadas', 'Sistema de evaluación por etapas', 'Plantilla editable de planificación'].map((item, i) => <li key={i} className="flex items-center text-gray-200 text-[9px] sm:text-sm" data-id="element-59">
                    <Check className="h-3 w-3 sm:h-4 sm:w-4 text-[#16a34a] mr-1 sm:mr-1.5 flex-shrink-0" strokeWidth={3} data-id="element-60" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}